import React from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldSelectIsActive,
} from 'motion-components';
import { useTranslation } from 'react-i18next';

export function buildWhereFromFilterValues(values): string {
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ code: { $like: searchText } }, { notes: { $like: searchText } }],
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (values.startDate || values.endDate) {
      where = {
        ...where,
        ...buildWhereForDates(values.startDate, values.endDate, 'productionDate'),
      };
    }
  }
  return JSON.stringify(where);
}

export const Filters = ({ onChange, initialValues, disable = false }) => {
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
    startDate: initialValues?.startDate ?? null,
    endDate: initialValues?.endDate ?? null,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση ( Κωδικός, Σημειώσεις )')}
          type="search"
          disable={disable}
        />
        <FieldDateRanger as={FormCol} label={t('Από')} name="startDate" name2="endDate" />
        <FieldSelectIsActive label={t('Ενεργές Παραγωγές')} disable={disable} />
      </Row>
    </FormFilterCard>
  );
};
